import {
  Backdrop,
  Box,
  CircularProgress,
  IconButton,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import HttpService from '../../hooks/Https-services';
import {
  API_ROUTES,
  dateFormat,
  PRIORITY,
  timeFormat,
} from '../../utils/constant';
import moment from 'moment';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
function ReportTable(props: {
  dateRangeReport: any;
  selectedTeamsKeys: any;
  selectedPriorityKeys: any;
  selectedTeams: any;
}) {
  const {
    dateRangeReport,
    selectedTeamsKeys,
    selectedTeams,
    selectedPriorityKeys,
  } = props;
  const [tableData, setTableData] = useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(10);
  const [totalCount, setTotalCount] = React.useState(0);
  const itemsPerPage = 10;
  const getTableData = React.useCallback(async () => {
    setLoading(true);
    try {
      const query: any = { page: currentPage, limit: itemsPerPage };
      if (dateRangeReport) {
        query.startDate = moment(dateRangeReport[0]).format('DD-MM-YYYY');
        query.endDate = moment(dateRangeReport[1]).format('DD-MM-YYYY');
      }
      if (selectedTeamsKeys.length > 0) {
        query.teamIds = selectedTeamsKeys.join(',');
      }
      if (selectedPriorityKeys.length > 0) {
        query.priority = selectedPriorityKeys.join(',');
      }
      // query.status = 'COMPLETED';
      const response = await HttpService.get(
        API_ROUTES.completedGameList +
          `?${new URLSearchParams(query).toString()}`
      );
      const apiData = response.data.data.list;
      setTableData(apiData);
      setTotalPages(response.data.data.totalPages);
      setTotalCount(response.data.data.totalCount);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching chart data:', error);
      setLoading(false);
    }
  }, [currentPage, selectedTeams, dateRangeReport, selectedPriorityKeys]);

  useEffect(() => {
    getTableData();
  }, [getTableData]);
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page); // Update the current page
  };
  return (
    <div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>GameId</TableCell>
              <TableCell>Priority</TableCell>
              <TableCell>Game Date</TableCell>
              <TableCell>Teams</TableCell>
              <TableCell>Fatched</TableCell>
              <TableCell>Completed</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.length > 0 ? (
              tableData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {row.gameId}
                    <Tooltip title="Copy Game ID">
                      <IconButton
                        onClick={() => {
                          navigator.clipboard.writeText(row.gameId);
                        }}
                        size="small"
                        sx={{ marginLeft: 1 }} // Add margin for spacing
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        background:
                          {
                            MINOR: '#eeeeee',
                            NORMAL: '#dbf2ff',
                            MAJOR: '#eb6f33',
                            CRITICAL: '#d30584',
                            SHOW_STOPPER: '#e30000',
                          }[PRIORITY[row.priority]] || '#ffffff', // Default to white if no match
                        color: '#000',
                        height: '40px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '0 10px',
                        borderRadius: 3,
                        fontWeight: 600,
                      }}
                    >
                      {PRIORITY?.[row?.priority]}
                    </Box>
                  </TableCell>
                  <TableCell>
                    {row?.game?.dateTime ? (
                      <Stack direction={'column'}>
                        <Typography variant="body2">
                          {moment(row?.game?.dateTime).format(`${dateFormat}`)}
                        </Typography>
                        <Typography variant="body2">
                          {moment(row?.game?.dateTime).format(`${timeFormat}`)}
                        </Typography>
                      </Stack>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                  <TableCell>
                    <div>
                      <span>{row?.game?.homeTeam?.nameEn}</span>
                      <br />
                      <span>{row?.game?.awayTeam?.nameEn}</span>
                    </div>
                  </TableCell>
                  <TableCell align="left">
                    {row?.createdAt ? (
                      <Stack direction={'column'}>
                        <Typography variant="body2">
                          {moment(row?.createdAt).format(`${dateFormat}`)}
                        </Typography>
                        <Typography variant="body2">
                          {moment(row?.createdAt).format(`${timeFormat}`)}
                        </Typography>
                      </Stack>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {row?.gameCompletedAt ? (
                      <Stack direction={'column'}>
                        <Typography variant="body2">
                          {moment(row?.gameCompletedAt).format(`${dateFormat}`)}
                        </Typography>
                        <Typography variant="body2">
                          {moment(row?.gameCompletedAt).format(`${timeFormat}`)}
                        </Typography>
                      </Stack>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3}>
                  {' '}
                  {/* Adjust colSpan based on the number of columns */}
                  <Typography>No Data</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </TableContainer>
      {/* Pagination Component */}
      <Box display="flex" justifyContent="center" my={2}>
        <Pagination
          count={totalPages} // Total number of pages
          page={currentPage} // Current page
          onChange={handlePageChange} // Handle page change
          color="primary"
        />
      </Box>
    </div>
  );
}

export default ReportTable;
